import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ExperianHeaderModule, CardListViewModule, HomeNotificationsModule } from 'experian-header-frontend-components';
import { FooterModule } from 'experian-shared-frontend';
import { GuidedTourModule, GuidedTourService } from 'ngx-guided-tour';

import { environment } from '../../../environments/environment';
import { DashboardComponent } from './dashboard.component';
import { TourMockupComponent } from '../tour/tour.component';
import { ButtonSerasaAlertaComponent } from '../button-serasa-alerta/button-serasa-alerta.component';
import { ModalVirtualTourModule } from '../modal-virtual-tour/modal-virtual-tour.module';
import { AnalyticsButtonDirective } from '../../shared/directives/analytics-button.directive';
import { ModalErrorModule } from '../modal-error/modal-error.module';

const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
  },
];
@NgModule({
  declarations: [
    AnalyticsButtonDirective,
    ButtonSerasaAlertaComponent,
    DashboardComponent,
  ],
  imports: [
    RouterModule.forChild(routes),
    CardListViewModule,
    CommonModule,
    ExperianHeaderModule.forRoot(environment),
    FooterModule,
    GuidedTourModule,
    HomeNotificationsModule,
    ModalErrorModule,
    ModalVirtualTourModule,
    TourMockupComponent
  ],
  exports: [
    RouterModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    { provide: 'Window', useValue: globalThis },
    GuidedTourService,
  ],
})
export class DashboardModule { }
